"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const t = useTranslations("cookiePolicy.head");

  return (
    <Header
      title={t("title")}
      containerClass="gs--page-column gs--page-column--prose"
    />
  );
};

export default Head;
